const getModelNameFromPath = (path: string): string => {
    // parse the input path to return the modal name
    // example: detectron2/semantic/lung-adenocarcinoma/pooja-normal-lung-001_data-scc-based-100k-added-normal_current.pth
    // the modal name is the last item, remove .path
    if (!path) return '';

    const parts = path.split('/');
    if (parts.length < 4) return '';

    const modelType = parts[2].replace(/-/g, ' ');
    const modelVersion = parts[3].split('_')[0].replace(/-/g, ' ');

    return `${modelType} - ${modelVersion}`;
}

export {
    getModelNameFromPath
}